import React from 'react';

export interface NavbarContext {
  activeAlerts?: number;
}

const navbarContext = React.createContext<NavbarContext>({
  activeAlerts: 0,
});

export default navbarContext;
